<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import WorkOrderTablePropertyCell from "../../../../../../_shared/_modules/work-order-table-property-cell"
  import type { CustomerSourceCleanupDraft, CustomerSourceCleanupRow } from "../../contract"

  let {
    row,
    disabled,
  }: InboxWorkflowCellProps<CustomerSourceCleanupRow, CustomerSourceCleanupDraft> = $props()
</script>

<WorkOrderTablePropertyCell addressLabel={row.addressLabel} unitLabel={row.unitLabel} {disabled} />
